// iter87.199.150 — Curated 2-4 letter team codes for the Matchday
// Breakdown modal's "Teams" column (EPL / La Liga / Serie A / NFL /
// CFB — the sports actually used by Matchday Boost templates today).
// Falls back to the first 3 letters of the name (uppercased) for
// anything not in the map, so new/rare teams never break the UI.
const TEAM_CODES = {
    // NFL
    "Arizona Cardinals": "ARI", "Atlanta Falcons": "ATL", "Baltimore Ravens": "BAL",
    "Buffalo Bills": "BUF", "Carolina Panthers": "CAR", "Chicago Bears": "CHI",
    "Cincinnati Bengals": "CIN", "Cleveland Browns": "CLE", "Dallas Cowboys": "DAL",
    "Denver Broncos": "DEN", "Detroit Lions": "DET", "Green Bay Packers": "GB",
    "Houston Texans": "HOU", "Indianapolis Colts": "IND", "Jacksonville Jaguars": "JAX",
    "Kansas City Chiefs": "KC", "Las Vegas Raiders": "LV", "Los Angeles Chargers": "LAC",
    "Los Angeles Rams": "LAR", "Miami Dolphins": "MIA", "Minnesota Vikings": "MIN",
    "New England Patriots": "NE", "New Orleans Saints": "NO", "New York Giants": "NYG",
    "New York Jets": "NYJ", "Philadelphia Eagles": "PHI", "Pittsburgh Steelers": "PIT",
    "San Francisco 49ers": "SF", "Seattle Seahawks": "SEA", "Tampa Bay Buccaneers": "TB",
    "Tennessee Titans": "TEN", "Washington Commanders": "WAS",
    // Premier League
    "Arsenal": "ARS", "Aston Villa": "AVL", "Bournemouth": "BOU", "Brentford": "BRE",
    "Brighton": "BHA", "Chelsea": "CHE", "Coventry": "COV", "Crystal Palace": "CRY",
    "Everton": "EVE", "Fulham": "FUL", "Hull City": "HUL", "Ipswich": "IPS",
    "Leeds": "LEE", "Liverpool": "LIV", "Manchester City": "MCI", "Manchester United": "MUN",
    "Newcastle": "NEW", "Nottingham Forest": "NFO", "Sunderland": "SUN", "Tottenham": "TOT",
    // La Liga
    "Alaves": "ALA", "Athletic Club": "ATH", "Atletico Madrid": "ATM", "Barcelona": "BAR",
    "Celta Vigo": "CEL", "Deportivo La Coruna": "DEP", "Elche": "ELC", "Espanyol": "ESP",
    "Getafe": "GET", "Levante": "LEV", "Malaga": "MAL", "Osasuna": "OSA",
    "Racing Santander": "RSA", "Rayo Vallecano": "RAY", "Real Betis": "BET",
    "Real Madrid": "RMA", "Real Sociedad": "RSO", "Sevilla": "SEV", "Valencia": "VAL",
    "Villarreal": "VIL",
    // Serie A
    "AC Milan": "MIL", "AS Roma": "ROM", "Atalanta": "ATA", "Bologna": "BOL",
    "Cagliari": "CAG", "Como": "COM", "Fiorentina": "FIO", "Frosinone": "FRO",
    "Genoa": "GEN", "Inter": "INT", "Juventus": "JUV", "Lazio": "LAZ", "Lecce": "LEC",
    "Monza": "MON", "Napoli": "NAP", "Parma": "PAR", "Sassuolo": "SAS", "Torino": "TOR",
    "Udinese": "UDI", "Venezia": "VEN",
    // CFB
    "Air Force": "AF", "Akron": "AKR", "Alabama": "ALA", "Appalachian State": "APP",
    "Arizona": "ARIZ", "Arizona State": "ASU", "Arkansas": "ARK", "Arkansas State": "ARST",
    "Army": "ARMY", "Auburn": "AUB", "BYU": "BYU", "Ball State": "BALL", "Baylor": "BAY",
    "Boise State": "BSU", "Boston College": "BC", "Bowling Green": "BGSU",
    "Buffalo State": "BUFF", "California": "CAL", "Central Michigan": "CMU",
    "Charlotte": "CLT", "Cincinnati": "CIN", "Clemson": "CLEM", "Coastal Carolina": "CCU",
    "Colorado": "COLO", "Colorado State": "CSU", "Delaware": "DEL", "Duke": "DUKE",
    "East Carolina": "ECU", "Eastern Michigan": "EMU", "Florida": "FLA",
    "Florida Atlantic": "FAU", "Florida International": "FIU", "Florida State": "FSU",
    "Fresno State": "FRES", "Georgia": "UGA", "Georgia Southern": "GASO",
    "Georgia State": "GAST", "Georgia Tech": "GT", "Hawai'i": "HAW", "Houston": "HOU",
    "Illinois": "ILL", "Indiana": "IND", "Iowa": "IOWA", "Iowa State": "ISU",
    "Jacksonville State": "JVST", "James Madison": "JMU", "Kansas": "KU",
    "Kansas State": "KSU", "Kennesaw State": "KENN", "Kent State": "KENT",
    "Kentucky": "UK", "LSU": "LSU", "Liberty": "LIB", "Louisiana": "LA",
    "Louisiana Tech": "LT", "Louisville": "LOU", "Marshall": "MRSH", "Maryland": "UMD",
    "Memphis": "MEM", "Miami": "MIA", "Miami (OH)": "M-OH", "Michigan": "MICH",
    "Michigan State": "MSU", "Middle Tennessee": "MTSU", "Minnesota": "MINN",
    "Mississippi State": "MSST", "Missouri": "MIZ", "Missouri State": "MOST",
    "NC State": "NCST", "Navy": "NAVY", "Nebraska": "NEB", "Nevada": "NEV",
    "New Mexico": "UNM", "New Mexico State": "NMSU", "North Carolina": "UNC",
    "North Texas": "UNT", "Northern Illinois": "NIU", "Northwestern": "NW",
    "Notre Dame": "ND", "Ohio": "OHIO", "Ohio State": "OSU", "Oklahoma": "OU",
    "Oklahoma State": "OKST", "Old Dominion": "ODU", "Ole Miss": "MISS", "Oregon": "ORE",
    "Oregon State": "ORST", "Penn State": "PSU", "Pittsburgh": "PITT", "Purdue": "PUR",
    "Rice Owls": "RICE", "Rutgers": "RUTG", "SMU": "SMU", "Sam Houston": "SHSU",
    "San Diego State": "SDSU", "San José State": "SJSU", "South Alabama": "USA",
    "South Carolina": "SC", "South Florida": "USF", "Southern Miss": "USM",
    "Stanford": "STAN", "Syracuse": "SYR", "TCU": "TCU", "Temple": "TEM",
    "Tennessee": "TENN", "Texas": "TEX", "Texas A&M": "TAMU", "Texas State": "TXST",
    "Texas Tech": "TTU", "Toledo": "TOL", "Troy": "TROY", "Tulane": "TULN",
    "Tulsa": "TLSA", "UAB": "UAB", "UCF": "UCF", "UCLA": "UCLA", "UConn": "CONN",
    "UL Monroe": "ULM", "UMass": "UMASS", "UNLV": "UNLV", "USC": "USC", "UTEP": "UTEP",
    "UTSA": "UTSA", "Utah": "UTAH", "Utah State": "USU", "Vanderbilt": "VAN",
    "Virginia": "UVA", "Virginia Tech": "VT", "Wake Forest": "WAKE", "Washington": "WASH",
    "Washington State": "WSU", "West Virginia": "WVU", "Western Kentucky": "WKU",
    "Western Michigan": "WMU", "Wisconsin": "WIS", "Wyoming": "WYO",
};

export function teamCode(name) {
    if (!name) return "?";
    if (TEAM_CODES[name]) return TEAM_CODES[name];
    return name.trim().replace(/[^A-Za-z]/g, "").slice(0, 3).toUpperCase() || "?";
}
